import React, { useState, useEffect } from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import MainBannerTab from './banner/MainBannerTab';
import RegularBannerTab from './banner/RegularBannerTab';
import TextAdTab from './banner/TextAdTab';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`banner-tabpanel-${index}`}
      aria-labelledby={`banner-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

const BannerManagement: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [tabValue, setTabValue] = useState(() => {
    // URL 쿼리 파라미터에서 탭 값 가져오기
    const tabFromUrl = searchParams.get('tab');
    if (tabFromUrl) {
      const tabIndex = parseInt(tabFromUrl);
      if (tabIndex >= 0 && tabIndex <= 2) {
        return tabIndex;
      }
    }
    
    // localStorage에서 탭 값 가져오기
    const savedTab = localStorage.getItem('bannerManagementTab');
    if (savedTab) {
      const tabIndex = parseInt(savedTab);
      if (tabIndex >= 0 && tabIndex <= 2) {
        return tabIndex;
      }
    }
    
    return 0; // 기본값
  });
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    
    // URL 쿼리 파라미터 업데이트
    setSearchParams({ tab: newValue.toString() });
    
    // localStorage에 저장
    localStorage.setItem('bannerManagementTab', newValue.toString());
  };

  const handleError = (message: string) => {
    setError(message);
  };

  const handleSuccess = (message: string) => {
    setSuccess(message);
  };

  // URL 쿼리 파라미터 변경 시 탭 업데이트
  useEffect(() => {
    const tabFromUrl = searchParams.get('tab');
    if (tabFromUrl) {
      const tabIndex = parseInt(tabFromUrl);
      if (tabIndex >= 0 && tabIndex <= 2 && tabIndex !== tabValue) {
        setTabValue(tabIndex);
        localStorage.setItem('bannerManagementTab', tabIndex.toString());
      }
    }
  }, [searchParams, tabValue]);

  return (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Banner Management
      </Typography>
      
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={tabValue} onChange={handleTabChange}>
          <Tab label="Main Banner" />
          <Tab label="Regular Banner" />
          <Tab label="Text Ad" />
        </Tabs>
      </Box>

      <TabPanel value={tabValue} index={0}>
        <MainBannerTab onError={handleError} onSuccess={handleSuccess} />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <RegularBannerTab onError={handleError} onSuccess={handleSuccess} />
      </TabPanel>
      <TabPanel value={tabValue} index={2}>
        <TextAdTab onError={handleError} onSuccess={handleSuccess} />
      </TabPanel>

      {/* 알림 */}
      {/* 알림 */}
      {/* 알림 */}
      {/* 알림 */}
    </Box>
  );
};

export default BannerManagement;
